import { Form, Input, Select } from 'antd';
import React, { useEffect } from 'react';
import {
  selectCountriesCodeList,
  selectMasterData,
} from 'modules/MasterData/slice/selectors';
import { useDispatch, useSelector } from 'react-redux';

import { useMasterDataSlice } from 'modules/MasterData/slice';

export default function PhoneInput({
  mobile,
  mobile_country_code,
  formLabel,
  mobileItemName,
  codeItemName,
  hideFlag,
  formItemProps,
  disableInput,
  onPhoneInputChange,
  isMobileItemRequired = true,
  isCountryCodeItemRequired = false,
}) {
  const { actions } = useMasterDataSlice();

  const dispatch = useDispatch();

  const countriesCodeList = useSelector(selectCountriesCodeList);
  const { loading: listLoading } = useSelector(selectMasterData);

  useEffect(() => {
    !countriesCodeList?.length && dispatch(actions.countriesCodeLoadStart());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form.Item
      {...formItemProps}
      name={mobileItemName || 'mobile'}
      label={formLabel}
      rules={[
        {
          pattern: /^[0-9]*$/,
          message: 'Phone number can be number only!',
        },
        {
          required: isMobileItemRequired,
          message: 'Please enter your Number!',
        },
        // {
        //   len: 10,
        //   message: 'Please enter all 10 digits!',
        // },
      ]}
      initialValue={mobile}
    >
      <Input
        // maxLength={10}
        disabled={disableInput}
        onChange={onPhoneInputChange}
        placeholder="9999999999"
        addonBefore={
          <Form.Item
            {...formItemProps}
            name={codeItemName || 'mobile_country_code'}
            noStyle
            initialValue={mobile_country_code || '91'}
            rules={[
              {
                required: isCountryCodeItemRequired,
                message: 'Please select your number country code!',
              },
            ]}
          >
            <Select
              disabled={disableInput}
              loading={listLoading}
              showSearch
              filterOption={(input, option) =>
                option.children.indexOf(input) >= 0
              }
            >
              {countriesCodeList.map(codeItem => (
                <Select.Option
                  key={codeItem.code}
                  value={codeItem.isd_code?.toString()}
                >
                  {!hideFlag && codeItem.flag_icon_url} {codeItem.dial_code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        }
        style={{ width: '100%' }}
      />
    </Form.Item>
  );
}
